import {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useInsights = () => {
  const { api, userID } = useContext(GlobalContext);

  const [insights, setInsights] = useState({});
  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  const fetchInsights = useCallback(async () => {
    if (!userID) return;

    try {
      setLoading(true);

      const data = await postRequest(
        "/Whatsapp/whatsappInsights",
        {
          userid: userID,
          secret: "string",
          fromDate: "string",
          toDate: "string",
        }
      );

      if (data?.responseCode === "00") {
        setInsights(data?.data || {});
      } else {
        setInsights({});
      }

      return data;
    } catch (err) {
      console.error(
        "Insights API Error:",
        err?.response?.data || err
      );

      setInsights({});

      return null;
    } finally {
      setLoading(false);
    }
  }, [userID, postRequest]);

  useEffect(() => {
    fetchInsights();
  }, [fetchInsights]);

  return {
    insights,
    loading,
    fetchInsights,
  };
};

export default useInsights;